<template>
  <div class="actions-container">
    <div class="m-2" v-if="showDownload">
      <a
        class="btn btn-light scen-action"
        :href="API_SUFFIX + '/api/scenarios/download/' + scenario.uuid_id"
        @click.prevent="downloadScenario"
      >
        <i class="material-icons">save_alt</i>
      </a>
    </div>
    <div class="m-2" v-if="showEditButton">
      <a
        class="btn btn-light scen-action"
        href="javascript:void(0)"
        @click.prevent="editScenario"
      >
        <i class="material-icons">edit</i>
      </a>
    </div>
    <div class="m-2">
      <button class="btn btn-light scen-action" @click="toggleFavourited()">
        <template v-if="favouritedByUser">
          <i class="material-icons">star</i>
        </template>
        <template v-else>
          <i class="material-icons">star_border</i>
        </template>
      </button>
    </div>
  </div>
</template>

<script>
import ScenService from "../services/scenarios.service";
import { mapState } from "vuex";

export default {
  name: "ScenarioActions",
  data: function () {
    return {
      API_SUFFIX: process.env.VUE_APP_API_SUFFIX,
    };
  },
  computed: {
    favouritedByUser() {
      let idx = this.$store.getters[
        "favouritesStore/favouriteScenarios"
      ].findIndex((scenario) => scenario.uuid_id === this.scenario.uuid_id);

      return idx !== -1;
    },
    showDownload() {
      let info = this.$store.getters.getDeviceInfo;

      return (
        !info.hasInfo ||
        (info.product.toLowerCase() === "ctgi" && this.ctgiScenario) ||
        (info.product.toLowerCase() !== "ctgi" && !this.ctgiScenario)
      );
    },
    ...mapState("favouritesStore", {
      isLoading: (state) => state.isLoadingFavouriteScenarios,
    }),
    showEditButton() {
      return this.$store.getters.getUser.id === this.scenario.contributed_by.id;
    }
  },
  props: {
    scenario: Object,
    ctgiScenario: Boolean,
  },
  methods: {
    toggleFavourited() {
      if (this.isLoading) return;

      if (this.favouritedByUser) {
        this.$store.dispatch(
          "favouritesStore/removeScenarioFromFavourites",
          this.scenario.uuid_id
        );
      } else {
        this.$store.dispatch(
          "favouritesStore/addScenarioToFavourites",
          this.scenario
        );
      }
    },
    downloadScenario() {
      ScenService.downloadScenario(this.scenario.uuid_id).then((data) => {
        if (window.webkit) {
          window.webkit.messageHandlers.scenarioimport.postMessage({
            url: data.url,
            fileName: data.fileName,
          });
        } else {
          window.location = data.url;
        }
      });
    },
    editScenario() {
      this.$router.push({
        name: "scenario-edit",
        params: { uuidId: this.scenario.uuid_id },
      });
    },
  },
};
</script>

<style scoped>
.actions-container {
  display: flex;
}

i {
  color: var(--isim-primary);
}

.scen-action {
  display: flex;
  width: 50px;
  height: 45px;
  align-items: center;
  justify-content: center;
}

@media (max-width: 1075px) {
  .actions-container {
    display: block;
  }
}

@media (max-width: 1025px) {
  .actions-container {
    display: flex;
  }
}
</style>
